var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRightArrow = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m8.59 16.34 4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgRightArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/rightArrow.b4f3f98edadfb13328911dac56c11662.svg";